import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { ISubmittalPackageDetail, ISubmittalPackageLevel2, ITestReportCategory, ITestReportSubCategory, ITestReportType, IDownloadSubmittal, ITestReportData, ISubmittalLbl } from '../../../core/models';
import { SubmittalPackageService } from '../../../core/services/submittal-package.service';
import { UserService } from '../../../core/services/user.service';
import { environment } from '../../../../environments/environment';
import * as fs from 'file-saver';
import { Subscription } from 'rxjs';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';

@Component({
  selector: 'app-submittal-package',
  templateUrl: './submittal-package.component.html',
  styleUrls: ['./submittal-package.component.scss']
})
export class SubmittalPackageComponent implements OnInit {
  //#region Member Variables
  submittalLbl: ISubmittalLbl;

  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;
  public continueLbl = "Continue";
  public showDetailsPanel = false;
  public showReportsPanel = false;

  multiSelectList: ISubmittalPackageDetail[];
  testReportGridView: GridDataResult;
  public testReportGridData: ITestReportData[] = [];

  public categoryData: ITestReportData[] = [];
  public categoryForFilterData: ITestReportData[] = [];
  public subCategoryData: ITestReportData[] = [];
  public subCategoryForFilterData: ITestReportData[] = [];
  public testTypeData: ITestReportData[] = [];
  public testTypeForFilterData: ITestReportData[] = [];
  public allTestReportData: ITestReportData[] = [];

  public saveInProcess: boolean;
  public selectionForm: FormGroup;
  languageCode: string;
  //#endregion
  constructor(private formBuilder: FormBuilder,
    private submittalPackageService: SubmittalPackageService, private userService: UserService,
    private languageTranslationService: LanguageTranslationService
  ) {
  }

  ngOnInit() {
    this.intializeForm();
    this.loadSelectionDropdown();
    this.loadLanguageTranslationData();
    this.languageCode = localStorage.getItem("language");

    //keeping below code in page load for now need to change 
    this.submittalPackageService.getArchitecturalDetails().subscribe((result) => {
      console.log(result);
      this.multiSelectList = result;
    });
  }

  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [{ controlName: "selectionsPanelLbl" },
    { controlName: "projectNameLbl" },
    { controlName: "projectLocationLbl" },
    { controlName: "aluminumCareLbl" },
    { controlName: "architecturalDetailsLbl" },
    { controlName: "architecturalDetailsTitleLbl" },
    { controlName: "customerVerficationLetterLbl" },
    { controlName: "leedPreSubmittalDocumentationLbl" },
    { controlName: "leedSubmittalDocumentationLbl" },
    { controlName: "productDeclareLbl" },
    { controlName: "environmentalProductLbl" },
    { controlName: "cradleLbl" },
    { controlName: "materialTransparencyLbl" },
    { controlName: "sampleWarrantiesLbl" },
    { controlName: "testReportsLbl" },
    { controlName: "glassDocumentsLbl" },
    { controlName: "paintDocumentsLbl" },
    { controlName: "testReportsPanelLbl" },
    { controlName: "productTypeLbl" },
    { controlName: "selectTestReportCategoryLbl" },
    { controlName: "selectTestReportSubCategoryLbl" },
    { controlName: "testTypeLbl" },
    { controlName: "addTestReportLbl" },
    { controlName: "testReportNoLbl" },
    { controlName: "testReportDescLbl" },
    { controlName: "continueLbl" },
    { controlName: "companyContactNameLbl" },
    { controlName: "kanweerTermsConditionsLbl" },
    { controlName: "termsAndConditionsPart1" },
    { controlName: "termsConditionsLbl" },
    { controlName: "downloadSubmittalLbl" },
    { controlName: "cancelLbl" },
    { controlName: "noTestReportAvailableLbl" },
    ];
    const componentName = "submittalPackage";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.submittalLbl = response[response.length - 1];
      console.log(response);
    } else {
      this.submittalLbl = response;
    }

  }
  //#endregion

  intializeForm() {
    this.selectionForm = this.formBuilder.group({
      projectName: new FormControl(),
      projectLocation: new FormControl(),
      aluminiumCare: new FormControl(),
      architectureDetails: new FormControl(),
      customerVarificationLetter: new FormControl(),
      preSubmittalDocument: new FormControl(),
      sampleWarranty: new FormControl(),
      testReport: new FormControl(),
      glassDocument: new FormControl(),
      paintDocument: new FormControl(),
      leedPreSubmittalDocument: new FormControl(),
      productDeclare: new FormControl(),
      environmentalProduct: new FormControl(),
      cradle: new FormControl(),
      materialTransparency: new FormControl(),
    });

  }
  //#region selection panel operations
  //#region label/variable declaration
  selectionFormLabel = {
    finishCategory: "Finish Catyegory",
    finish: "Finish",
    quantity: "Quantity",
    selectionsPanelLbl: "SELECTIONS",
    projectNameLbl: "Project Name",
    projectLocationLbl: "Project Location",
    aluminumCareLbl: "Aluminum Care & Cleaning",
    architecturalDetailsLbl: "Architectural Details",
    customerVerficationLetterLbl: "Customer Verification Letter",
    leedPreSubmittalDocumentationLbl: "LEED Pre-Submittal Documentation",
    leedSubmittalDocumentationLbl: "LEED Pre-Submittal Documentation",
    productDeclareLbl: "Product Declare Label",
    environmentalProductLBL: "Environmental Product Declarations (EPD)",
    cradleLBL: "Cradle to Cradle",
    materialTransparencyLBL: "Material Transparency Summaries (MTS)",
    sampleWarrantiesLbl: "Sample Warranties",
    testReportsLbl: "Test Report(s)",
    glassDocumentsLbl: "Glass Documents (Windows)",
    paintDocumentsLbl: "Finish/Paint Documents (Windows)",
  }
  selectionDetails = {
    isSubmitted: false,
    isEmptyProjectName: false,
    isEmptyProjectLocation: false,
    isSelectionPanelValid: false
  }
  showDetail = {
    isSubmitted: false,
    isEmptyProjectName: false,
    isEmptyProjectLocation: false,
    isSelectionPanelValid: false
  }
  //#endregion
  //#region Selection multi select dropdown data---hardcoded for now need to confirm
  sampleWarrantiesData = [];
  glassDocumentsData = [];
  paintDocumentsData = [];
  leedPreSubmittalDocumentData = [];
  productDeclareData = [];
  EnvironmentalProductsData = [];
  cradleData = [];
  MaterialTransparencyData = [];
  public loadSelectionDropdown() {
    this.sampleWarrantiesData = [
      { value: 1, name: 'Anodize' },
      { value: 2, name: 'InsulatedGlass' },
      { value: 3, name: 'LaminatedGlass' },
      { value: 4, name: 'Material/Workmanship' },
      { value: 5, name: 'Paint' },
      { value: 6, name: 'Project Warranty Cover Sheet' }
    ];
    this.glassDocumentsData = [
      { value: 1, name: 'IGCC Certificate' },
      { value: 2, name: 'PPG Glass Certified Fabricators' },
      { value: 3, name: 'Safety Glazing Certification (SGCC)Finish / Paint Documents(Windows)' },
    ];
    this.paintDocumentsData = [
      { value: 1, name: 'PPG Applicator Certificate' }
    ];
    //leed multiselect data
    this.leedPreSubmittalDocumentData = [
      { value: "LeedPreSubmittalDocumentation", name: 'LEED v4 Building Design & Construction' },
    ];
    this.productDeclareData = [
      { value: "DLA010", name: '190/350/500 Standard Entrances Kawneer Company, Inc.' },
      { value: "DLA090", name: '250T/350T/500T InsulPour™ Thermal Entrances Kawneer Company, Inc.' },
      { value: "DLC040", name: 'Trifab® VersaGlaze® 400/450/451/451T and Trifab® 601T Framing Systems' },
      { value: "DLC060", name: 'Trifab™ 451UT and Trifab™ 601UT Framing Systems Kawneer Company, Inc.' },
      { value: "DLC093", name: 'IR 521/521T/521UT and IR 501/501T/501UT Framing Systems Kawneer Company, Inc.' },
      { value: "DLD010", name: '1600 Wall System™ 1 Curtain Wall and System™ 2 Curtain Wall Kawneer Company, Inc.' },
      { value: "DLD080", name: '1600UT SS Curtain Wall System, 1600UT System™ 1 Curtain Wall and 1600UT System™ 2 Curtain Wall Systems' },
      { value: "DLD100", name: 'Clearwall™ Curtain Wall Systems Kawneer Company, Inc.' },
      { value: "DLD230", name: 'Versoleil™ Sunshade Outrigger Systems and Versoleil™ Single Blade Systems for Storefront and Curtain Wall and InLighten L.S' },
      { value: "DLE070", name: 'GLASSvent™ Windows for Storefront Framing and Curtain Wall and GLASSvent™ UT Windows Kawneer Company, Inc.' },
      { value: "DLG030", name: 'Versoleil® Sunshade Outrigger Systems and Versoleil® Single Blade Systems for Storefront and Curtain Wall and InLighten L.S' },
      { value: "DLD210", name: '1620/1620 SSG Curtain Wall System' },
      { value: "DLD215", name: '1620UT/1620UT SSG Curtain Wall System ' },
    ];
    this.EnvironmentalProductsData = [
      { value: "EPD47868332121.101", name: 'FIXED & RIBBON WINDOWS' },
      { value: "EPD47868332121.102", name: 'HUNG & SLIDING WINDOWS' },
      { value: "EPD47868332121.103", name: 'PROJECTED & CASEMENT WINDOWS' },
      { value: "EPD47868332121.104", name: 'TRIFAB™ FRAMING SYSTEMS AND STOREFRONT FRAMING SYSTEMS' },
      { value: "EPD47868332121.105", name: 'TRADITIONAL CURTAIN WALL' },
      { value: "EPD47868332121.106", name: 'ALUMINUM EXTRUSIONS' },
      { value: "EPD47868332121.107", name: 'GLASSVENTTM WINDOWS' },
      { value: "EPD47868332121.108", name: 'OVERHEAD GLAZING' },
      { value: "EPD47868332121.109", name: 'UNITIZED CURTAIN WALL' },
      { value: "EPD47868332121.110", name: 'WINDOW WALL' },
      //{ value: "EPDTS47868332121.101", name: 'FIXED AND RIBBON WINDOWS' },
      //{ value: "EPDTS47868332121.102", name: 'HUNG AND SLIDING WINDOWS' },
      //{ value: "EPDTS47868332121.103", name: 'PROJECTED A& CASEMENT WINDOWS' },
      //{ value: "EPDTS47868332121.104", name: 'ALUMINUM STOREFRONT FRAMING SYSTEMS' },
      //{ value: "EPDTS47868332121.105", name: 'ALUMINUM CURTAIN WALL SYSTEMS' },
      //{ value: "EPDTS47868332121.106", name: 'ANODIZED,PAINTED AND MILL-FINISH ' },
      //{ value: "EPDTS47868332121.107", name: 'GLASSVENT™ WINDOWS ' },
      //{ value: "EPDTS47868332121.108", name: 'ALUMINUM SLOPED CURTAIN WALL ' },
      //{ value: "EPDTS47868332121.109", name: 'Unitized Curtain wall featuring 2500 UT Unitwall™ Systems ' },
      //{ value: "EPDTS47868332121.110", name: 'Window wall featuring Metro View™ FG 50T Window Wall' },
    ];
    this.cradleData = [
      //{ value: "CERT4355", name: 'Bronze-Versoleil™ Sunshade Outrigger Systems and Versoleil™ Single Blade Systems' },
      // { value: "CERT4356", name: 'Bronze-Kawneer 1600 Wall System™ 1 Curtain Wall and System™ 2 Curtain Wall' },
      { value: "CERT5967", name: 'Bronze - 1620 Captured and Structural Silicone Glazed (SSG) Curtain Wall Systems' },
      { value: "CERT5968", name: 'Bronze - Versoleil™ Sun Control/1600 Wall System™ 1 and 2 System™ Curtain Wall' },
      // { value: "MHC4355", name: 'Silver-Versoleil™ Sunshade Outrigger Systems and Versoleil™ Single Blade Systems' },
      // { value: "MHC4356", name: 'Silver-Kawneer 1600 Wall System™ 1 Curtain Wall and System™ 2 Curtain Wall' },
      { value: "MHC5967", name: 'Bronze - Material Health Certificate - 1620 Captured and Structural Silicone Glazed (SSG) Curtain Wall Systems' },
      { value: "MHC5968", name: 'Silver - Material Health Certificate - Versoleil™ Sun Control/1600 Wall System™ 1 and 2 System™ Curtain Wall' },
    ];
    this.MaterialTransparencyData = [
      { value: 'MTSA010EN', name: '190/350/500 Standard Entrances' },
      { value: 'MTSA030EN', name: '350/500 Heavy Wall™ Entrances' },
      { value: 'MTSA090EN', name: '250T/350T/500T Insulpour™ Thermal Entrances' },
      { value: 'MTSC020EN', name: 'Trifab™ VersaGlaze™ 450/451 Framing and Trifab™ 601 Framing Systems' },
      { value: 'MTSC040EN', name: 'Trifab™ VersaGlaze™ 451T Framing and Trifab™ 601T Framing Systems' },
      { value: 'MTSC040IREN', name: 'Impact Resistance Trifab™ VersaGlaze™ 451/451T and Trifab™ 601/601T Framing Systems, and IR 500/501 Framing' },
      { value: 'MTSC060EN', name: 'Trifab™ 451UT and 601UT Framing Systems' },
      { value: 'MTSC080EN', name: 'EnCORE™ Framing System' },
      /* { value: 'MTSC093EN', name: 'IR 501T/501UT Framing' },*/
      { value: 'MTSC140EN', name: 'InFrame™ Interior Framing System' },
      { value: 'MTSD010EN', name: '1600 Wall System™1 Curtain Wall and System™2 Curtain Wall' },
      { value: 'MTSD010IREN', name: 'Impact Resistant 1600 Wall System™1 Curtain Wall and System™2 Curtain Wall' },
      { value: 'MTSD030EN', name: '1600 Wall System™3 Curtain Wall and System™4 Curtain Wall' },
      { value: 'MTSD050EN', name: '1600 Wall System™5 Curtain Wall' },
      { value: 'MTSD060EN', name: '1600 SS Curtain Wall System' },
      { value: 'MTSD070EN', name: '1600 LR Wall™ Curtain Wall System' },
      { value: 'MTSD080EN', name: '1600UT Wall System™ 1 Curtain Wall and System™ 2 Curtain Wall' },
      { value: 'MTSD100EN', name: 'Clearwall™ Curtain Wall System' },
      { value: 'MTSD210EN', name: '1620/1620 SSG Curtain Wall System' },
      { value: 'MTSD215EN', name: '1620UT/1620UT SSG Curtain Wall System' },
      { value: 'MTSD230EN', name: '2500 UT Unitwall™ System' },
      { value: 'MTSE077EN', name: 'GLASSvent™ Windows for Storefront Framing and Curtain Wall and GLASSvent™ UT Windows' },
      { value: 'MTSG030EN', name: 'Versoleil™ SunShade - Outrigger and Single Blade Systems for Curtain Wall and Storefront' },
      { value: 'MTSD061EN', name: '1600UT SS Curtain Wall System' },
      { value: 'MTSC093EN', name: 'IR 501T/501UT and IR 521T/521UT Framing' },
      { value: 'MTSC040IREN', name: 'IR 500/501 and IR 521 Framing' },
    ];
  }

  //#endregion
  showLeedMultiSelectDropdown: boolean = false;
  showLeedMuiltiSelect() {
    this.showLeedMultiSelectDropdown = !this.showLeedMultiSelectDropdown;
    if (this.showLeedMultiSelectDropdown == false) {
      this.selectionForm.controls.leedPreSubmittalDocument.reset();
      this.selectionForm.controls.productDeclare.reset();
      this.selectionForm.controls.environmentalProduct.reset();
      this.selectionForm.controls.cradle.reset();
      this.selectionForm.controls.materialTransparency.reset();
    }
  }

  public showDetails() {
    this.updateProductPicker();
  }
  public updateProductPicker() {
    if ((this.selectionForm.controls.architectureDetails.value) && (!this.selectionForm.controls.testReport.value)) {
      this.detailsPanellabel.title = "ARCHITECTURAL DETAILS";
      this.showDetailsPanel = true;
    } else if ((!this.selectionForm.controls.architectureDetails.value) && (this.selectionForm.controls.testReport.value)) {
      this.detailsPanellabel.title = "Product Picker";
      this.showDetailsPanel = true;
    } else if ((this.selectionForm.controls.architectureDetails.value) && (this.selectionForm.controls.testReport.value)) {
      this.detailsPanellabel.title = "Product Picker";
      this.showDetailsPanel = true;
    } else if ((!this.selectionForm.controls.architectureDetails.value) && (!this.selectionForm.controls.testReport.value)) {
      this.detailsPanellabel.title = "ARCHITECTURAL DETAILS";
      this.showDetailsPanel = false;
    }
    else {
      this.detailsPanellabel.title = "ARCHITECTURAL DETAILS";
      this.showDetailsPanel = false;
    }
  }
  public showReports() {

    if (this.selectionForm.controls.testReport.value) {
      this.showReportsPanel = true;
    } else {
      this.showReportsPanel = false;

    }
    this.updateProductPicker();
  }
  public validateSelectionForm(): boolean {
    let isValid = true;
    const controls = this.selectionForm.controls;
    if (this.selectionDetails.isSubmitted) {
      if (controls.projectName.value) {
        this.selectionDetails.isEmptyProjectName = false;
      } else {
        this.selectionDetails.isEmptyProjectName = true;
        isValid = false;
      }
      if (controls.projectLocation.value) {
        this.selectionDetails.isEmptyProjectLocation = false;
      } else {
        this.selectionDetails.isEmptyProjectLocation = true;
        isValid = false;
      }

    }
    return isValid;
  }
  //#endregion

  //#region details panel operations
  detailsPanellabel = {
    title: "ARCHITECTURAL DETAILS"
  }
  tempSelected: any = [];
  productTypeData: ISubmittalPackageLevel2[] = [];
  productTypeTempData: ISubmittalPackageLevel2[] = [];
  multiSelectChange(event, index: number, item) {
    console.log(event);
    if (event.length === 0) {
      //remove all entries for this particular dropdown
      const lv1Key = this.multiSelectList[index].multiSelectData[0].submittalLevel1key;
      let d = this.tempSelected.filter(x => x.submittalLevel1key !== lv1Key);
      d = d.concat(event);
      this.tempSelected = d;
    }
    else if (event.length > 0) {//
      const lv1Key = event[0].submittalLevel1key;
      let d = this.tempSelected.filter(x => x.submittalLevel1key !== lv1Key);
      d = d.concat(event);
      this.tempSelected = d;
    }
    item.selectedValues = event;
    console.log(this.tempSelected);
    this.productTypeData = this.tempSelected;
    this.productTypeTempData = this.tempSelected;
    this.testReportData.productType = [];
  }
  multiSelectLeave() {
  }
  //#endregion
  //#region Test report panel operations
  testReport = {
    testReportsPanelLbl: "Test Reports",
    productTypeLbl: "Product Type",
    selectTestReportCategoryLbl: "Test Report Category",
    selectTestReportSubCategoryLbl: "Test Report Sub-Category",
    testTypeLbl: "Test Type",
    addTestReportLbl: "Add Test Reports",
    testReportNoLbl: "Test Report No.",
    testReportDescLbl: "Test Report Description",
    noTestReportAvailableLbl: "No Test Reports available online for Product Selected. Please contact your Kawneer Representative.",
  }

  //testReportlabel = {
  //  title: "Test Reports",
  //  productType: "Product Type",
  //  category: "Test Report Category",
  //  subCategory: "Test Report Sub-Category",
  //  testType: "Test Type",
  //  addReport: "Add Test Reports",
  //  testReportNumber: "Test Report No.",
  //  testReportDescription: "Test Report Description",
  //}
  testReportData = {
    productType: [],
    category: [],
    subCategory: [],
    testType: [],
    isSubmitted: false,
    isEmptyProductType: false,
    isTestReportPanelValid: false,
    isTestReportContinue: false
  }

  public validateTestReportForm(): boolean {
    let isValid = true;

    if (this.testReportData.isSubmitted) {
      if (this.testReportData.productType.length > 0) {
        this.testReportData.isEmptyProductType = false;
      } else {
        this.testReportData.isEmptyProductType = true;
        isValid = false;
      }
    }
    return isValid;
  }

  addTestReport() {
    this.testReportData.isSubmitted = true;
    if (!this.validateTestReportForm()) {
      return;
    }
    if (this.testReportData.productType.length > 0) {
      if (this.testReportData.testType.length > 0) {
        //let data = this.testReportData.testType as ITestReportData[];
        let data = this.allTestReportData.filter(f => this.testReportData.testType.some(item => item.submittalLevel4key === f.submittalLevel4key
          && item.reportNumber === f.reportNumber));
        for (var i = 0; i < data.length; i++) {
          if (this.testReportGridData.map(function (e) { return e.reportNumber; }).indexOf(data[i].reportNumber) === -1) {
            this.testReportGridData.push(data[i]);
          }
        }
        this.loadtestReportGrid();
      }
      else if (this.testReportData.subCategory.length > 0) {
        let data = this.allTestReportData.filter(f => this.testReportData.subCategory.some(item => item.submittalLevel3key === f.submittalLevel3key));
        for (var i = 0; i < data.length; i++) {
          if (this.testReportGridData.map(function (e) { return e.reportNumber; }).indexOf(data[i].reportNumber) === -1) {
            this.testReportGridData.push(data[i]);
          }
        }
        this.loadtestReportGrid();
      }
      else if (this.testReportData.category.length > 0) {
        let data = this.allTestReportData.filter(f => this.testReportData.category.some(item => item.submittalLevel2key === f.submittalLevel2key));
        for (var i = 0; i < data.length; i++) {
          if (this.testReportGridData.map(function (e) { return e.reportNumber; }).indexOf(data[i].reportNumber) === -1) {
            this.testReportGridData.push(data[i]);
            console.log(data[i]);
          }
        }
        this.loadtestReportGrid();
      }
      else {
        let filterArray = this.allTestReportData;
        for (var i = 0; i < filterArray.length; i++) {
          if (this.testReportGridData.map(function (e) { return e.reportNumber; }).indexOf(filterArray[i].reportNumber) === -1) {
            this.testReportGridData.push(filterArray[i]);
          }
        }
        this.loadtestReportGrid();
      }
      this.testReportData.productType = [];
      this.testReportData.category = [];
      this.testReportData.subCategory = [];
      this.testReportData.testType = [];
      this.testReportData.isSubmitted = false;
    }
  }
  deleteTestReport(rowIndex) {
    this.testReportGridData.splice(rowIndex, 1);
    this.loadtestReportGrid();
  }
  handleCategoryFilter(event, item) {
    if (!event) {
      item.filteredmultiSelectData = item.multiSelectData;
      return;
    }
    item.filteredmultiSelectData = item.multiSelectData.filter(
      (s) => s.subCategory.toLowerCase().indexOf(event.toLowerCase()) !== -1
    );
  }
  handleProductTypeFilter(event) {
    if (!event) {
      this.productTypeData = this.productTypeTempData;
      return;
    }
    const filterArray = this.productTypeTempData.filter(x => x.subCategory != null);
    this.productTypeData = filterArray.filter(
      (s) => s.subCategory.toLowerCase().indexOf(event.toLowerCase()) !== -1
    );
  }
  handleTestCategoryFilter(event) {
    if (!event) {
      this.categoryData = this.categoryForFilterData;
      return;
    }
    const filterArray = this.categoryForFilterData.filter(x => x.testReportCategory != null);
    this.categoryData = filterArray.filter(
      (s) => s.testReportCategory.toLowerCase().indexOf(event.toLowerCase()) !== -1
    );
  }
  handleTestSubCategoryFilter(event) {
    if (!event) {
      this.subCategoryData = this.subCategoryForFilterData;
      return;
    }
    const filterArray = this.subCategoryForFilterData.filter(x => x.testReportSubCategory != null);
    this.subCategoryData = filterArray.filter(
      (s) => s.testReportSubCategory.toLowerCase().indexOf(event.toLowerCase()) !== -1
    );
  }
  handleTestTypeFilter(event) {
    if (!event) {
      this.testTypeData = this.testTypeForFilterData;
      return;
    }
    const filterArray = this.testTypeForFilterData.filter(x => x.productOptTested != null);
    this.testTypeData = filterArray.filter(
      (s) => s.productOptTested.toLowerCase().indexOf(event.toLowerCase()) !== -1
    );
  }

  productTypeLeave() {
    this.submittalPackageService.getTestReportData(this.testReportData.productType).subscribe((result) => {
      if (result) {
        this.allTestReportData = result as ITestReportData[];
        let filterArray = this.allTestReportData.filter((v, i, a) => a.findIndex(t => (t.submittalLevel3key === v.submittalLevel3key)) === i);
        this.categoryData = filterArray as ITestReportCategory[];
        this.categoryForFilterData = filterArray as ITestReportCategory[];
        if (this.categoryData.length <= 0 && this.testReportData.productType.length > 0) {
          this.defaultNoTestReportValue();
        }
      }
    });
  }
  categoryLeave() {
    let filterArray = this.allTestReportData.filter(f => this.testReportData.category.some(item => item.submittalLevel3key === f.submittalLevel3key));
    filterArray = filterArray.filter((v, i, a) => a.findIndex(t => (t.submittalLevel4key === v.submittalLevel4key)) === i);
    this.subCategoryData = filterArray as ITestReportCategory[];
    this.subCategoryForFilterData = filterArray as ITestReportCategory[];
    console.log(filterArray);

  }
  subCategoryleave() {
    let filterArray = this.allTestReportData.filter(f => this.testReportData.subCategory.some(item => item.submittalLevel4key === f.submittalLevel4key));
    //filterArray = filterArray.filter((v, i, a) => a.findIndex(t => (t.submittalLevel4key === v.submittalLevel4key)) === i);
    this.testTypeData = filterArray as ITestReportCategory[];
    this.testTypeForFilterData = filterArray as ITestReportCategory[];
    console.log(filterArray);

  }
  defaultNoTestReportValue() {
    this.categoryData = [];
    this.categoryForFilterData = [];
    const noData = { testReportCategory: "No Test Reports available online for Product Selected. Please contact your Kawneer Representative." } as ITestReportCategory;
    this.categoryData.push(noData);
  }

  //#region sorting,filtering,pagination of grid
  loadtestReportGrid() {
    this.testReportGridView = process(this.testReportGridData, this.testReportGridstate);
  }
  public testReportGridstate: State = {
    sort: [],
    skip: 0,
    take: 10,
    group: [],
    filter: null,
  };
  public testReportGridSortChange(sort): void {
    this.testReportGridstate.sort = sort;
    this.loadtestReportGrid();
  }
  public testReportGridPageChange({ skip, take }: PageChangeEvent): void {
    this.testReportGridstate.skip = skip;
    this.testReportGridstate.take = take;
    this.loadtestReportGrid();

  }
  public testReportDataStateChange(state: DataStateChangeEvent): void {
    this.testReportGridstate = state;
    this.loadtestReportGrid();
  }

  //#endregion
  //#endregion
  //#region generate submittal panel operations
  //generateSubmittalLabel = {
  //  title: "Generate Submittal",
  //  companyContactName: "Company Contact Name",
  //  acceptTermsCondition: "Accept Terms & Conditions",
  //  downloadSubmittal: "Download Submittal Package",
  //  cancel: "Cancel",
  //  termsConditionHeading: "Kawneer Submittal Package Terms and Conditions",
  //  termsConditionContent: "In submitting this request you represent and warrant that you are authorized by your company to make this request, and that the documentation being sought is to be used for a lawful purpose"
  //}
  generateSubmittal = {
    generateSubmittalPanelLbl: "Generate Submittal",
    companyContactNameLbl: "Company Contact Name",
    termsConditionsLbl: "I Accept Terms & Conditions",
    downloadSubmittalLbl: "Download Submittal Package",
    cancelLbl: "Cancel",
    kanweerTermsConditionsLbl: "Kawneer Submittal Package Terms and Conditions",
    termsAndConditionsPart1: "In submitting this request you represent and warrant that you are authorized by your company to make this request, and that the documentation being sought is to be used for a lawful purpose"
  }

  generateSubmittalData = {
    companyContactName: "",
    termsCheck: false,
  }
  downloadSubmittalPackageValidation(): boolean {
    let isvalid = false;
    if (!this.selectionDetails.isSelectionPanelValid) {
      this.selectionDetails.isSubmitted = true;
      isvalid = false;
      return isvalid;
    }
    if (this.showDetailsPanel && !this.showDetail.isSelectionPanelValid) {
      this.showDetail.isSubmitted = true;
      isvalid = false;
      return isvalid;
    }
    if (this.showReportsPanel && !this.testReportData.isTestReportPanelValid) {
      this.testReportData.isTestReportContinue = true;
      isvalid = false;
      return isvalid;
    }


    isvalid = true;
    return isvalid;
  }
  public downloadSubmittalPackageSub: Subscription;
  downloadSubmittalPackage() {
    //perform operation here
    this.selectionDetails.isSubmitted = true;
    if (!this.validateSelectionForm()) {
      this.selectionDetails.isSelectionPanelValid = false;
      return;
    }
    this.selectionDetails.isSelectionPanelValid = true;
    const controls = this.selectionForm.controls;
    if (controls.testReport.value) {
      this.testReportData.isTestReportContinue = true;
      if (this.testReportGridData.length > 0) {
        this.testReportData.isTestReportPanelValid = true;
      } else {
        this.testReportData.isTestReportPanelValid = false;
      }
    }
    if (!this.downloadSubmittalPackageValidation()) {
      return;
    }
    this.saveInProcess = true;
    const body: IDownloadSubmittal = {
      coverSheet: false,
      projectName: controls.projectName.value,
      projectLocation: controls.projectLocation.value,
      aluminiumCare: controls.aluminiumCare.value ? controls.aluminiumCare.value : false,
      architectureDetails: controls.architectureDetails.value ? controls.architectureDetails.value : false,
      customerVarificationLetter: controls.customerVarificationLetter.value ? controls.customerVarificationLetter.value : false,
      preSubmittalDocument: controls.preSubmittalDocument.value ? controls.preSubmittalDocument.value : false,
      sampleWarranty: controls.sampleWarranty.value,
      testReport: controls.testReport.value ? controls.testReport.value : false,
      paintDocument: controls.paintDocument.value,
      architectureDetailsData: this.tempSelected,
      testReportData: this.testReportGridData,
      companyContactName: this.generateSubmittalData.companyContactName,
      customerName: this.userService.readUserObject.customerName,
      customerNumber: this.userService.readUserObject.customerNumber,
      userName: this.userService.readUserObject.userName,
      userLanguage: localStorage.getItem("language"),
      //requestedBy: `${this.userService.readUserObject.userFirstName} ${this.userService.readUserObject.userLastName}`,     ----prints username in downloaded document
      requestedBy: this.generateSubmittalData.companyContactName ? this.generateSubmittalData.companyContactName : `${this.userService.readUserObject.userFirstName} ${this.userService.readUserObject.userLastName}`,
      leedPreSubmittalDocument: controls.leedPreSubmittalDocument.value,
      productDeclare: controls.productDeclare.value,
      environmentalProduct: controls.environmentalProduct.value,
      cradle: controls.cradle.value,
      materialTransparency: controls.materialTransparency.value,
    }
    this.downloadSubmittalPackageSub = this.submittalPackageService.downloadSubmittal(body).subscribe((response) => {
      ///TempDocs/d6be6566 - 5caa - 46d4 - b6c2 - 35da9d49b8c3.pdf
      if (response.downloadString) {
        //Code to open pdf in new tab------------Start
        //var byteCharacters = atob(response.downloadString);
        //var byteNumbers = new Array(byteCharacters.length);
        //for (var i = 0; i < byteCharacters.length; i++) {
        //  byteNumbers[i] = byteCharacters.charCodeAt(i);
        //}
        //var byteArray = new Uint8Array(byteNumbers);
        //var file = new Blob([byteArray], { type: 'application/pdf;base64' });

        //const fileURL = URL.createObjectURL();

        //let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        //fs.saveAs(`${environment.apiUrl}${response.downloadString}`, 'SubmittalPackage.pdf',{
        //    type: "application/pdf"
        //  });
        //window.open(`${environment.apiUrl}${response.downloadString}`);
        //Code to open pdf in new tab------------End
        //Code to download pdf automatically----------- Start                        

        const linkSource = 'data:application/pdf;base64,' + response.downloadString;
        const downloadLink = document.createElement("a");
        const fileName = "SubmittalPackage.pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        //Code to download pdf automatically----------- End 
      }
      this.saveInProcess = false;
      this.resetSubmittalForm();
    });
  }

  resetSubmittalForm() {
    this.showDetail.isSubmitted = false;
    this.showDetail.isSelectionPanelValid = false;
    this.selectionDetails.isSubmitted = false;
    this.selectionDetails.isSelectionPanelValid = false;
    this.selectionForm.reset();
    this.testReportData.isTestReportContinue = false;
    this.testReportData.isTestReportPanelValid = false;
    this.testReportData.productType = [];
    this.testReportData.category = [];
    this.testReportData.subCategory = [];
    this.testReportData.testType = [];
    this.testReportGridData = [];
    this.showLeedMultiSelectDropdown = false
  }
  cancel() {
    this.saveInProcess = false;
    if (this.downloadSubmittalPackageSub) this.downloadSubmittalPackageSub.unsubscribe();

  }
  //#endregion
  //#region panel change
  continueToNextPanel() {
    this.selectionDetails.isSubmitted = true;
    if (!this.validateSelectionForm()) {
      this.selectionDetails.isSelectionPanelValid = false;
      return;
    }
    this.selectionDetails.isSelectionPanelValid = true;
    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
    });
    this.panel.childrenItems[1].expanded = true;
    this.panel.childrenItems[1].selected = true;

  }

  continueToGenerateSubmittal() {
    this.showDetail.isSubmitted = true;
    if (this.productTypeData.length < 1) {
      this.showDetail.isSelectionPanelValid = false;
      return;
    } else {
      this.showDetail.isSelectionPanelValid = true;
    }


    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
      this.panel.childrenItems[2].expanded = true;
      this.panel.childrenItems[2].selected = true;
    });
  }
  testReportContinue() {
    this.testReportData.isTestReportContinue = true;
    if (this.testReportGridData.length > 0) {
      this.testReportData.isTestReportPanelValid = true;
      this.panel.childrenItems.forEach(item => {
        if (item.expanded) {
          item.expanded = false;
          item.selected = false;
        }
        if (this.showDetailsPanel == true) {
          this.panel.childrenItems[3].expanded = true;
          this.panel.childrenItems[3].selected = true;
        } else {
          this.panel.childrenItems[2].expanded = true;
          this.panel.childrenItems[2].selected = true;
        }

      });
    } else {
      this.testReportData.isTestReportPanelValid = false;
    }

  }
  //#endregion

  //#region Some helper methods---will be moved to separate file
  removeDuplicateByKeys(arr: any[], key1: string, key2: string) {
    //room for improvement
    //arr.filter((v, i, a) => a.findIndex(t => (t.[key1] === v.[key1] && t.[key2] === v.[key2])) === i)
  }
  //#endregion
}
